<template>
  <div class="chart-wrap" ref="chart"></div>
</template>

<script>
import $ from 'jquery'
import _ from 'lodash'
import echarts from 'echarts'

export default {
  props: {
    dataSets: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      chart: null
    }
  },
  mounted () {
    this.init()
    this.setResize()
  },
  methods: {
    init () {
      this.chart = echarts.init(this.$refs.chart)

      const option = {
        color: ['#4FB786'],
        title: {
          text: this.dataSets.title,
          textStyle: {
            fontSize: 20
          }
        },
        tooltip: this.dataSets.tooltip || {},
        xAxis: this.dataSets.xAxis || {},
        yAxis: this.dataSets.yAxis || {},
        series: [{
          name: this.dataSets.dataName,
          type: 'bar',
          barWidth: '10px',
          data: this.dataSets.data
        }]
      }

      this.chart.setOption(option)
    },
    setResize () {
      $(window).on('resize.chart', _.debounce(() => {
        if (!this.chart) return
        this.chart.resize()
      }, 500))
    }
  }
}
</script>

<style lang="stylus" scoped>
  .chart-wrap
    width 100%
    height 100%
</style>
